import { route } from '@/ziggy-shim';
import { api, apiConfig, CastValue } from './LaravelClient';

export default {
  async create(claimId: Id, tradeItemId: Id, data: ApiRequests['api.v1.trade-item-costs.store']) {
    return await api(route('api.v1.trade-item-costs.store', [claimId, tradeItemId]), 'post', {
      data,
      casts: {
        current_certified: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        current_claim: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        comment: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.trade-item-costs.update']) {
    return await api(route('api.v1.trade-item-costs.update', id), 'patch', {
      data,
      casts: {
        current_certified: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        current_claim: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        comment: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async updateComment(
    tradeItemCostId: Id,
    commentId: Id,
    data: ApiRequests['api.v1.trade-item-costs.comments.update'],
  ) {
    return await api(route('api.v1.trade-item-costs.comments.update', [tradeItemCostId, commentId]), 'patch', {
      data,
    });
  },

  async deleteComment(tradeItemCostId: Id, commentId: Id) {
    return await api(route('api.v1.trade-item-costs.comments.destroy', [tradeItemCostId, commentId]), 'delete');
  },

  async delete(id: Id) {
    return await api(route('api.v1.trade-item-costs.destroy', id), 'delete');
  },

  async certifiedSingle(claimId: Id, signedParams: unknown, data: ApiRequests['api.v1.claims.certified.store']) {
    return await apiConfig(route('api.v1.claims.certified.store', claimId), 'post', {
      params: signedParams,
      paramsSerializer: {
        serialize: (params) => {
          return new URLSearchParams(params).toString();
        },
      },
    }, {
      data,
      casts: {
        comment_trade_item: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        comment: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async claimSingle(claimId: Id, signedParams: unknown, data: ApiRequests['api.v1.claims.claim.store']) {
    return await apiConfig(route('api.v1.claims.claim.store', claimId), 'post', {
      params: signedParams,
      paramsSerializer: {
        serialize: (params) => {
          return new URLSearchParams(params).toString();
        },
      },
    }, {
      data,
    });
  },

  comments: {
    async updateSigned(
      claimId: Id,
      signedParams: unknown,
      data: ApiRequests['api.v1.claims.trade-item-costs.comments.update.signed'],
    ) {
      return await apiConfig(route('api.v1.claims.trade-item-costs.comments.update.signed', claimId), 'patch', {
        params: signedParams,
        paramsSerializer: {
          serialize: (params) => {
            return new URLSearchParams(params).toString();
          },
        },
      }, {
        data,
      });
    },

    async storeSigned(
      claimId: Id,
      signedParams: unknown,
      data: ApiRequests['api.v1.claims.trade-item-costs.comments.store.signed'],
    ) {
      return await apiConfig(route('api.v1.claims.trade-item-costs.comments.store.signed', claimId), 'post', {
        params: signedParams,
        paramsSerializer: {
          serialize: (params) => {
            return new URLSearchParams(params).toString();
          },
        },
      }, {
        data,
      });
    },
  },
};
